import { render } from "./SearchCandidates.vue?vue&type=template&id=2a89139f"
import script from "./SearchCandidates.vue?vue&type=script&lang=js"
export * from "./SearchCandidates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__